module.exports = __webpack_public_path__ + "assets/img/CreateNewAccount@2x.538e4910.png";